import { Response } from '@marketplace-web/shared/api-client'

import {
  ItemPerformanceDto,
  ItemPerformanceModel,
  ItemPerformanceResponse,
} from '../types/item-performance'

export const transformItemPerformance = (dto: ItemPerformanceDto): ItemPerformanceModel => ({
  impressions: dto.impressions,
  favorites: dto.favorites,
  views: dto.views,
  conversations: dto.conversations,
  humanizedHoursLeft: dto.humanized_hours_left,
  promotionEndedDaysAgo: dto.promotion_ended_days_ago,
  recentlyPromoted: dto.recently_promoted,
  impressionDifference: dto.impression_difference,
  chartData: dto.chart_data,
})

export const transformItemPerformanceResponse = (response: Response<ItemPerformanceResponse>) => {
  return response.item_performance ? transformItemPerformance(response.item_performance) : null
}
